import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	resetViewSettingsButton: {
		id: 'issue-navigator-save-reset-view-settings-button.reset-view-settings-button',
		defaultMessage: 'Reset view back to default',
		description: 'Label for the button to allow users to reset changes made to the view settings',
	},
	saveOrResetViewSettingsButton: {
		id: 'issue-navigator-save-reset-view-settings-button.save-or-reset-view-settings-button',
		defaultMessage: 'Save or reset view settings',
		description:
			'Label for the menu trigger button to allow users to save or reset changes made to the view settings',
	},
	saveViewSettingsMenuItem: {
		id: 'issue-navigator-save-reset-view-settings-button.save-view-settings-menu-item',
		defaultMessage: 'Save view',
		description: 'Label for the menu item to allow users to save changes made to the view settings',
	},
	resetViewSettingsMenuItem: {
		id: 'issue-navigator-save-reset-view-settings-button.reset-view-settings-menu-item',
		defaultMessage: 'Reset to last saved',
		description:
			'Label for the menu item to allow users to reset changes made to the view settings',
	},
	saveSettingsSuccessTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.save-settings-success-title',
		defaultMessage: 'View saved',
		description: 'Success title informing the user saving view settings succeeded.',
	},
	saveSettingsSuccessMessage: {
		id: 'issue-navigator-save-reset-view-settings-button.save-settings-success-message',
		defaultMessage: 'This view has been updated for everyone in this project.',
		description: 'Success message informing the user saving view settings succeeded.',
	},
	saveSettingsFailedTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.save-settings-failed-title',
		defaultMessage: 'Unable to save your settings',
		description: 'Error title informing the user saving view settings failed.',
	},
	saveSettingsFailedMessage: {
		id: 'issue-navigator-save-reset-view-settings-button.save-settings-failed-message',
		defaultMessage: "We couldn't save your settings, try refreshing the page or try again later.",
		description: 'Error message informing the user saving view settings failed.',
	},
	resetSettingsFailedTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.reset-settings-failed-title',
		defaultMessage: 'Unable to reset your settings',
		description: 'Error title informing the user resetting view settings failed.',
	},
	resetSettingsFailedMessage: {
		id: 'issue-navigator-save-reset-view-settings-button.reset-settings-failed-message',
		defaultMessage: "We couldn't reset your settings, try refreshing the page or try again later.",
		description: 'Error message informing the user resetting view settings failed.',
	},
	saveConfirmationModalTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.save-confirmation-modal-title',
		defaultMessage: 'Save view',
		description: 'Title for the modal to confirm saving the view settings',
	},
	saveConfirmationModalBody: {
		id: 'issue-navigator-save-reset-view-settings-button.save-confirmation-modal-body',
		defaultMessage:
			"The view will be saved for everyone in the project. They'll see the applied filters, grouping, fields, and columns.",
		description: 'Description for the modal to confirm saving the view settings',
	},
	saveButton: {
		id: 'issue-navigator-save-reset-view-settings-button.save-button',
		defaultMessage: 'Save',
		description: 'Label for the button to confirm saving the view settings',
	},
	cancelButton: {
		id: 'issue-navigator-save-reset-view-settings-button.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Label for the button to cancel saving the view settings',
	},
});
